module.exports = __webpack_public_path__ + "img/instagram-icon.10b6ad36.svg";